import type { LocalLibraryHealthStatus } from './LocalLibraryAdapter';

export function mapTauriHealthStatusPayload(payload: Record<string, unknown>): LocalLibraryHealthStatus {
  return {
    status: (payload?.status || 'unknown') as LocalLibraryHealthStatus['status'],
    message: (payload?.message as string | null | undefined) ?? null,
    lastRunAt: (payload?.lastRunAt as number | null | undefined) ?? null,
    mappedLegacyCount: (payload?.mappedLegacyCount as number | null | undefined) ?? null,
    unresolvedLegacyCount: (payload?.unresolvedLegacyCount as number | null | undefined) ?? null,
    rebuilding: payload?.rebuilding === true,
    code: typeof payload?.code === 'string' ? payload.code : null,
    migrationPending: payload?.migrationPending === true || payload?.migration_pending === true,
    albumsWithZeroPresentTracks: payload?.albumsWithZeroPresentTracks != null
      ? Number(payload.albumsWithZeroPresentTracks)
      : null,
  };
}
